import { site } from "@/config/site";
import { Breadcrumbs } from "./Breadcrumbs";
import { WhatsAppButton, CallButton } from "./CtaButtons";

export const PageHero = ({ eyebrow, title, accent, text, crumbs, testId = "page-hero" }) => (
  <section className="relative isolate overflow-hidden bg-night text-white" data-testid={testId}>
    <img src={site.heroImage} alt="" width="1200" height="800" className="absolute inset-0 h-full w-full object-cover opacity-50" aria-hidden="true" />
    <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" aria-hidden="true" />
    <div className="absolute inset-0 bg-emerald/20 mix-blend-multiply" aria-hidden="true" />
    <div className="relative container-wide py-14 md:py-20">
      <Breadcrumbs items={crumbs} light />
      <div className="max-w-3xl mt-6 reveal">
        {eyebrow && <span className="inline-flex items-center rounded-full border border-gold/50 bg-gold/15 px-4 py-1.5 text-xs md:text-sm text-gold backdrop-blur mb-5">{eyebrow}</span>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight" data-testid="page-h1">
          {accent && <span className="gold-text">{accent} </span>}{title}
        </h1>
        {text && <p className="mt-5 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl">{text}</p>}
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <CallButton testId="page-hero-call" />
          <WhatsAppButton testId="page-hero-whatsapp" />
        </div>
      </div>
    </div>
  </section>
);
